import unique_id from "../../../../Lib/helpers/unique_id";
import Palette   from "../../../../Domain/Palette/Palette";

/**
 * Makes some data to seed the app if no one is authenticated
 */
export default class AppDataSource {

    get() {
        let id = unique_id('p');
        return [
            new Palette({
                "id"        : id,
                "name"      : "Palette Name",
                "notes"     : "These are your notes for this palette!",
                "swatches"  : [
                    { "name": "Swatch 1", "color": { "red": 255, "green": 205, "blue": 73 } },
                    { "name": "Swatch 2", "color": { "red": 181, "green": 0, "blue": 151 } },
                    { "name": "Swatch 4", "color": { "red": 240, "green": 88, "blue": 59 } },
                    { "name": "Swatch 3", "color": { "red": 0, "green": 108, "blue": 228 } },
                    { "name": "Swatch 5", "color": { "red": 0, "green": 0, "blue": 0 } }
                ],
                "share_token" : id,
                "share_link": false,
            })
        ];
    }

}
